import React from 'react';
interface StatusBadgeProps {
  status: string;
  className?: string;
}
export function StatusBadge({
  status,
  className = ''
}: StatusBadgeProps) {
  let bgColor = 'bg-gray-100';
  let textColor = 'text-gray-800';
  const normalizedStatus = status.toLowerCase();
  if (['active', 'approved', 'excellent', 'passed', 'processed', 'published', 'issued'].includes(normalizedStatus)) {
    bgColor = 'bg-green-100';
    textColor = 'text-green-800';
  } else if (['pending', 'submitted', 'average', 'pending approval'].includes(normalizedStatus)) {
    bgColor = 'bg-yellow-100';
    textColor = 'text-yellow-800';
  } else if (['rejected', 'blacklisted', 'poor', 'failed', 'disposal', 'expired'].includes(normalizedStatus)) {
    bgColor = 'bg-red-100';
    textColor = 'text-red-800';
  } else if (['draft', 'info'].includes(normalizedStatus)) {
    bgColor = 'bg-blue-100';
    textColor = 'text-blue-800';
  } else if (['inactive', 'good', 'returned', 'repair'].includes(normalizedStatus)) {
    bgColor = 'bg-orange-100';
    textColor = 'text-orange-800';
  } else if (['local', 'international'].includes(normalizedStatus)) {
    bgColor = 'bg-indigo-100';
    textColor = 'text-indigo-800';
  }
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor} ${className}`} data-id="element-508">
      {status}
    </span>;
}